<template>
  <div class="no-box-shadow-expand">
    <v-card>
      <v-card-text>
        <v-row no-gutters class="mb-3">
          <InventoryTemplateTagsEditor
            v-model="tags"
          ></InventoryTemplateTagsEditor>
        </v-row>
        <v-data-table
          :headers="getHeaders"
          :items="
            tags.length > 0
              ? items
                  .filter(x => x.est_intermediaire === true)
                  .filter(
                    x => x.data && tags.every(t => x.data.tags.includes(t))
                  )
              : items.filter(x => x.est_intermediaire === true)
          "
          :search="search"
          item-key="id"
          sort-by="origin_quantity"
          :sort-desc="true"
          show-expand
          dense
          hide-default-footer
          @page-count="pageCount = $event"
          :page.sync="page"
          :items-per-page="15"
        >
          <template v-slot:item.nom="{ item }">
            <span class="font-weight-bold">{{ item.nom }}</span>
          </template>
          <template v-slot:item.quantity_min="{ item }">
            <v-row align="center" no-gutters dense justify="end">
              <j-decimal-input
                filled
                single-line
                dense
                hide-details
                unit-suffix
                class="no-before my-1"
                :value="item.quantity_min"
                :suffix="getProductUnit(item)"
                @input="v => (item.quantity_min = v)"
                style="max-width: 200px;"
              ></j-decimal-input>
            </v-row>
          </template>
          <template v-slot:item.quantity="{ item }">
            <v-row align="center" no-gutters dense justify="end">
              <j-decimal-input
                filled
                single-line
                dense
                hide-details
                unit-suffix
                class="no-before my-1"
                :value="item.quantity"
                :suffix="getProductUnit(item)"
                @input="v => (item.quantity = v)"
                style="max-width: 200px;"
              ></j-decimal-input>
            </v-row>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-card flat>
                <v-card-text class="pr-0">
                  <v-simple-table dense class="no-border ml-2">
                    <template v-slot:default>
                      <tbody>
                        <tr
                          v-for="ingredient in getIngredientsValues(item)"
                          :key="ingredient.id"
                        >
                          <td width="250">{{ ingredient.name }}</td>
                          <td>
                            <v-row align="end" justify="end" no-gutters>
                              <span class="font-weight-bold">
                                {{ ingredient.quantity }}
                              </span>
                              <span class="caption ml-1">{{
                                ingredient.unit
                              }}</span>
                            </v-row>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </td>
          </template>
          <template v-slot:top>
            <v-row align="center" justify="end" dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  dense
                  filled
                  hide-details
                  single-line
                  clearable
                  prepend-inner-icon="fa-search"
                  v-model="search"
                  class="no-before"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:footer>
            <v-pagination
              color="#757575"
              v-model="page"
              :length="pageCount"
              :total-visible="5"
            ></v-pagination>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { round10 } from "round10";
import { mappers } from "@/mappers";
import { InventoryTemplateTagsEditor } from "@/modules/Inventory/components";
export default {
  name: "PreparationSlipTemplateEditorGrid",
  components: {
    InventoryTemplateTagsEditor
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    showMin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getRecipes", "getProducts"]),
    getHeaders() {
      if (this.showMin === true) {
        return [
          { value: "nom", text: "Produit" },
          { value: "quantity_min", text: "Quantité minimum", align: "end" },
          { value: "quantity", text: "Quantité selon les ventes", align: "end" }
        ];
      } else {
        return [
          { value: "nom", text: "Produit" },
          { value: "quantity", text: "Quantité pour la journée", align: "end" }
        ];
      }
    }
  },
  data() {
    return {
      tags: [],
      tabs: 0,
      search: "",
      page: 1,
      pageCount: 0,
      headers: [
        { value: "nom", text: "Produit" },
        { value: "quantity_min", text: "" },
        { value: "quantity", text: "Quantité pour la journée", align: "end" }
      ]
    };
  },
  methods: {
    getIngredientsValues(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      if (recipe) {
        const ingredients = this.$store.getters.getIngredientsByRecipe(
          recipe.id
        );
        return ingredients.map(x => {
          const ingredientProduct = this.getProducts.find(
            p => p.id === x.pk_recette_produit.id
          );
          if (ingredientProduct) {
            const item_quantity = recipe.data.use_conversion_formula
              ? mappers.recipeInvToProd(item.quantity, recipe, recipe.data)
              : item.quantity;
            const item_required_quantity = recipe.data.use_conversion_formula
              ? mappers.recipeInvToProd(
                  item.quantity_required_recipe,
                  recipe,
                  recipe.data
                )
              : item.quantity_required_recipe;

            let ingredient_quantity = x.quantite;
            if (ingredientProduct.data.use_conversion_formula) {
              if (x.is_alternative_unite_mesure === true) {
                if (
                  !mappers.isCustomUnit(x.unite_mesure) &&
                  !mappers.isCustomUnit(
                    ingredientProduct.data.alternative_unite_mesure_production
                  )
                ) {
                  ingredient_quantity = this.$units(x.quantite)
                    .from(x.unite_mesure)
                    .to(
                      ingredientProduct.data.alternative_unite_mesure_production
                    );
                }
              } else {
                if (
                  !mappers.isCustomUnit(x.unite_mesure) &&
                  !mappers.isCustomUnit(ingredientProduct.data.unite_mesure)
                ) {
                  ingredient_quantity = this.$units(x.quantite)
                    .from(x.unite_mesure)
                    .to(ingredientProduct.data.unite_mesure);
                }
              }
            } else {
              if (
                !mappers.isCustomUnit(x.unite_mesure) &&
                !mappers.isCustomUnit(
                  ingredientProduct.data.unite_mesure_inventory
                )
              ) {
                ingredient_quantity = this.$units(x.quantite)
                  .from(x.unite_mesure)
                  .to(ingredientProduct.data.unite_mesure_inventory);
              }
            }

            let quantity = round10(
              (ingredient_quantity * item_quantity) / recipe.quantite_produite,
              -6
            );
            let quantity_required_recipe = round10(
              (ingredient_quantity * item_required_quantity) /
                recipe.quantite_produite,
              -6
            );

            return {
              name: ingredientProduct.nom,
              quantity: quantity,
              quantity_required_recipe: quantity_required_recipe,
              quantity_required: round10(
                quantity + quantity_required_recipe,
                -6
              ),
              unit: ingredientProduct.data.use_conversion_formula
                ? x.is_alternative_unite_mesure
                  ? ingredientProduct.data.alternative_unite_mesure_production
                  : ingredientProduct.data.unite_mesure
                : ingredientProduct.data.unite_mesure_inventory
            };
          } else {
            return {
              name: "Ingrédient inconnue"
            };
          }
        });
      }
    },
    getProductUnit(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      if (recipe) {
        if (recipe.data && recipe.data.use_conversion_formula) {
          return recipe.data.unite_inventory;
        } else {
          return recipe.unite_produite;
        }
      } else {
        return item.data && item.data.unite_mesure_inventory
          ? item.data.unite_mesure_inventory
          : item.data && item.data.unite_mesure
          ? item.data.unite_mesure
          : "";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
